import { useMutation } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import financialBff from '~/services-v2/financial-bff/financial-bff'

export default function useChangeCredentials(brand: string) {
  const mutationKey = queryKeys.INSTALLATION.CHANGE_CREDENTIALS(brand)

  const mutationFn = async (
    { brandParam, passwordParam }: { brandParam: string, passwordParam: string },
  ) => {
    const res = await financialBff('mutation')({
      device_orchestrator_credentials_change: [
        {
          brand: brandParam,
          password: passwordParam,
        },
        {
          success: true,
          message: true,
        },
      ],
    })

    return res.device_orchestrator_credentials_change
  }

  return useMutation({
    mutationKey,
    mutationFn,
    retry: 0,
  })
}
